export const ADMINS_ROLES = [

  { id: 'super_admin', name: 'Супер Админ' },
  { id: 'content_manager', name: 'Контент-менеджер' }

]